module.exports = __webpack_public_path__ + "img/AccentureLogo.00d2beff.png";